export const tasksProjectsViewRoutesName = {
    tasksProjectsView: "tasks-projects-view",
};
